import { useState, useEffect, useRef } from 'react';
import {
  ContentContainer,
  Input,
  Label,
  Select,
  Option
} from '../../../../../styles/component.styles';
// import AccordionSection from '../../../../reusable/accordion-section/accordion-section.component';

const YouTubeUpdateSection = ({ content = {}, metadata = {}, onChange }) => {
  const [youtubeUrl, setYoutubeUrl] = useState(content?.youtubeUrl || '');

  const [align, setAlign] = useState(metadata?.align || 'center');
  const [background, setBackground] = useState(metadata?.background || 'transparent');
  const [padding, setPadding] = useState(metadata?.padding || '2rem 0');
  const [margin, setMargin] = useState(metadata?.margin || '2rem 0');

  const prev = useRef({});

  useEffect(() => {
    const updatedContent = { youtubeUrl };
    const updatedMetadata = { align, background, padding, margin };
    const current = JSON.stringify({ content: updatedContent, metadata: updatedMetadata });

    if (prev.current !== current) {
      prev.current = current;
      onChange({ content: updatedContent, metadata: updatedMetadata });
    }
  }, [youtubeUrl, align, background, padding, margin, onChange]);

  return (
    <>
      <Label>YouTube Video URL</Label>
      <Input
        value={youtubeUrl}
        onChange={(e) => setYoutubeUrl(e.target.value)}
        placeholder="https://www.youtube.com/watch?v=..."
      />

      {/* <AccordionSection title="Advanced Style Options">
        <ContentContainer>
          <Label>Alignment</Label>
          <Select value={align} onChange={(e) => setAlign(e.target.value)}>
            <Option value="left">Left</Option>
            <Option value="center">Center</Option>
            <Option value="right">Right</Option>
          </Select>

          <Label>Background Color</Label>
          <Input
            type="text"
            value={background}
            onChange={(e) => setBackground(e.target.value)}
            placeholder="e.g. #f0f0f0 or transparent"
          />

          <Label>Padding</Label>
          <Input
            type="text"
            value={padding}
            onChange={(e) => setPadding(e.target.value)}
            placeholder="e.g. 2rem 0"
          />

          <Label>Margin</Label>
          <Input
            type="text"
            value={margin}
            onChange={(e) => setMargin(e.target.value)}
            placeholder="e.g. 2rem 0"
          />
        </ContentContainer>
      </AccordionSection> */}
    </>
  );
};

export default YouTubeUpdateSection;
